import * as Sentry from '@sentry/browser';

export const init = () => {
  if (!window.PROJECT) {
    return;
  }

  const { PROJECT } = window;

  try {
    Sentry.init(PROJECT.sentry);

    if (PROJECT.user) {
      Sentry.setUser(PROJECT.user);
    }
  } catch (e) {
    // console.error(e);
  }
};

export default {
  init,
};
